import React from "react";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import TestPackage from "../section-component/test-package/TestPackage";
import FeatureSection from "../section-component/feature-section/FeatureSection";
import SampleQuestion from "../section-component/sample-question/SampleQuestion";
import MentorEvaluation from "../section-component/mentor-evaluation/MentorEvaluation";
import CallToAction from "../section-component/call-to-action/CallToAction";
import LiveChat from "../section-component/live-chat/LiveChat";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";
import { ArrowRightCircle } from "lucide-react";
import CallToActionBanner from "../home/call-to-action-banner/CallToActionBanner";

const TestSeriesIndex = () => {
    return (
        <>
            

            <TestPackage />
            <FeatureSection />
            <SampleQuestion />
            <MentorEvaluation />
            <CallToActionBanner />

            
        </>
    );
};

export default TestSeriesIndex;
